export const SESSION_IDLE_MS = 8 * 60 * 60 * 1000;
export const SESSION_KEYS = ['accessToken', 'refreshToken', 'user', 'lastActiveTime'];

export function decodeJwt(token) {
  try {
    const segment = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(segment.padEnd(Math.ceil(segment.length / 4) * 4, '=')), c => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch { return null; }
}

export function isIdleExpired(value, now = Date.now()) {
  const timestamp = Number(value);
  return Number.isFinite(timestamp) && timestamp > 0 && now - timestamp >= SESSION_IDLE_MS;
}

export function clearSession(storage) {
  SESSION_KEYS.forEach(key => storage.removeItem(key));
}

// Share one refresh across all requests in a tab. Never resurrect a signed-out session.
export function createTokenRefresher(storage, request) {
  let pending = null;
  return () => {
    if (pending) return pending;
    pending = (async () => {
      const refreshToken = storage.getItem('refreshToken');
      if (!refreshToken) throw Object.assign(new Error('Phiên đăng nhập đã hết hạn.'), { invalidSession: true });
      const tokens = await request(refreshToken);
      if (storage.getItem('refreshToken') !== refreshToken) {
        throw Object.assign(new Error('Phiên đăng nhập đã thay đổi.'), { sessionChanged: true });
      }
      if (!tokens?.accessToken || !tokens?.refreshToken) {
        throw Object.assign(new Error('Phản hồi phiên đăng nhập không hợp lệ.'), { invalidSession: true });
      }
      storage.setItem('accessToken', tokens.accessToken);
      storage.setItem('refreshToken', tokens.refreshToken);
      return tokens;
    })().finally(() => { pending = null; });
    return pending;
  };
}
